import { ModalWrapper } from '@modals/core-ui/ModalWrapper';

type TProps = {
  onCancel: () => void;
};

export const OfflineModal = ({ onCancel }: TProps) => {
  return (
    <ModalWrapper onCancel={onCancel}>
      <div className="modal-banner">
        <h2 className="modal-banner__title py-[15px]">Offline</h2>
        <div className="px-[30px] pb-[35px] pt-[30px] text-base font-normal leading-6">
          Please check your internet connection
        </div>
      </div>
    </ModalWrapper>
  );
};
